module.exports = __webpack_public_path__ + "cbb4002fb08c22b83c3a247a033c44c4.jpg";